import { staticContentAxios as axios } from './configuration/axiosConfig';
import { ClientResponse } from '../model/types/ClientResponse';
import { DataResponseWithHistoriaFlag } from '../model/DataResponseWithHistoriaFlag';

export const getChronologickyRegisterZakonovHistoriaHtmlContent = async (
  year: string | undefined,
  number: string | undefined,
)
  : Promise<ClientResponse<DataResponseWithHistoriaFlag>> => {
  const {
    data,
    status,
  } = await axios.get(
    `/static/SK/ZZ/${year}/${number}/index.portal`,
  );
  return {
    data: { response: data, historia: true },
    responseCode: status,
  };
};
